import * as REDUX_TYPES from '../types'

const INITIAL_STATE = {
    allowSwipe: true,
    containDisplay: false,
    continuousPlay: false,
    reactorPlay: false,
    showSearch: false,
    transactionInProgress:false
}

const displayReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REDUX_TYPES.DISPLAY.ALLOW_SWIPE:
            return {
                ...state,
                allowSwipe: action.allowSwipe,
            }

        case REDUX_TYPES.DISPLAY.CONTAIN_DISPLAY:
            return {
                ...state,
                containDisplay: action.containDisplay,
            }

        case REDUX_TYPES.DISPLAY.CONTINUOUS_PLAY:
            return {
                ...state,
                continuousPlay: action.continuousPlay,
            }

        case REDUX_TYPES.DISPLAY.REACTOR_PLAY:
            return {
                ...state,
                reactorPlay: action.reactorPlay,
            }
        case REDUX_TYPES.DISPLAY.SHOW_SEARCH:
            return {
                ...state,
                showSearch: action.showSearch,
            }
        case REDUX_TYPES.DISPLAY.TRANSACTION_IN_PROGRESS:
            return {
                ...state,
                transactionInProgress: action.transactionInProgress,
            }            
        default:
            return state
    }
}
export default displayReducer